import { Injectable } from '@angular/core';
import { Browser } from '@capacitor/browser';
import { environment } from 'src/environments/environment';
import { UtilsService } from './utils/utils.service';

@Injectable({
  providedIn: 'root'
})
export class BrowserService {

  constructor(private utilsService: UtilsService) { }

  /**
   * Abre una URL externa utilizando el plugin Browser de Capacitor
   * @param url La URL a abrir
   */
  async openExternalUrl(url: string): Promise<void> {
    await Browser.open({ url });
  }

  /**
   * Abre los términos y condiciones usando el plugin Browser de Capacitor
   */
  async openTermsAndConditions(): Promise<void> {
    await this.openExternalUrl(environment.termsAndConditionsUrl);
  }

  /**
   * Abre la política de privacidad usando el plugin Browser de Capacitor
   */
  async openPrivacyPolicy(): Promise<void> {
    await this.openExternalUrl(environment.privacyPolicyUrl);
  }

  /**
   * Abre la política de cookies usando el plugin Browser de Capacitor
   */
  async openCookiePolicy(): Promise<void> {
    await this.openExternalUrl(environment.cookiePolicyUrl);
  }

  /**
   * Abre la política de reembolsos usando el plugin Browser de Capacitor
   */
  async openRefundPolicy(): Promise<void> {
    await this.openExternalUrl(environment.refundPolicyUrl);
  }

  /**
   * Abre el aviso legal usando el plugin Browser de Capacitor
   */
  async openLegalNotice(): Promise<void> {
    await this.openExternalUrl(environment.legalNoticeUrl);
  }
}
